import { Table, TableColumnsType } from "antd";
import { useTheme } from "../../../Context/ThemeContext";
import { dayjs } from "../../../../Utilities/dayjs";

const GSTR2A = ({
  gst2ATable3ReportsData,
  gst2ATable4ReportsData,
  gst2ATable5ReportsData,
}: any) => {
  const { themeData } = useTheme();

  const sharedOnCell = (rec: any, index?: number) => {
    if (rec.rowType === 1) {
      return { colSpan: 0 };
    }
    return {};
  };
  const table3n4Columns: TableColumnsType<any> = [
    {
      title: "GSTIN of Suppliers",
      dataIndex: "rowType",
      key: "key",
      onCell: (record, index) => ({
        colSpan: record?.rowType === 1 ? 14 : 1,
      }),
      render: (_, record: any) =>
        record?.rowType === 1 ? (
          <p style={{ fontWeight: "bold" }}>{record?.partyGSTNo}</p>
        ) : (
          <>{record?.partyGSTNo}</>
        ),
    },
    // {
    //   title: "Trade / Legal Name",
    //   dataIndex: "partyName",
    //   key: "partyName",
    //   onCell: sharedOnCell,
    // },
    {
      title: "Invoice Details",
      children: [
        {
          title: "Number",
          dataIndex: "supplierInvoiceRef",
          key: "SupplierInvoiceRef",
          align: "center",
          onCell: sharedOnCell,
        },
        // {
        //   title: "Type",
        //   dataIndex: "voucherType",
        //   key: "voucherType",
        //   onCell: sharedOnCell,
        //   render: (_, record: any) => <>{record?.voucherType}</>,
        // },
        {
          title: "Date",
          dataIndex: "supplierInvoiceDate",
          key: "SupplierInvoiceRef",
          align: "center",
          onCell: sharedOnCell,
          render: (invDate: any, _) =>
            invDate && dayjs(invDate).format("DD/MM/YYYY"),
        },
        {
          title: "Value",
          dataIndex: "invoiceValue",
          key: "invoiceValue",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
    // {
    //   title: "Supply Attract Reverse Charge",
    //   dataIndex: "supply",
    //   key: "supply",
    //   onCell: sharedOnCell,
    //   render: (_: any, record: any) =>
    //     record.rowType !== 1 && (
    //       <>
    //         <p>No</p>
    //       </>
    //     ),
    // },
    {
      title: "Rate(%)",
      dataIndex: "rate",
      key: "rate",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "HSN/SAC",
      dataIndex: "hsnsac",
      key: "hsnsac",
      align: "center",
      onCell: sharedOnCell,
    },
    {
      title: "Taxable Value",
      dataIndex: "taxableAmount",
      key: "taxableAmount",
      align: "right",
      onCell: sharedOnCell,
    },
    {
      title: "Tax Amount",

      children: [
        {
          title: "Integrated",
          dataIndex: "igstAmt",
          key: "igstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "Central",
          dataIndex: "cgstAmt",
          key: "cgstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "State/UT",
          dataIndex: "sgstAmt",
          key: "sgstAmt",
          align: "right",
          onCell: sharedOnCell,
        },
        {
          title: "Cess",
          dataIndex: "cessAmt",
          key: "cessAmt",
          align: "right",
          onCell: sharedOnCell,
        },
      ],
    },
    {
      title: "Place of Suppliers",
      dataIndex: "supplyState",
      key: "supplyState",
      onCell: sharedOnCell,
      render: (_: any, record: any) => <>{record?.supplyState}</>,
    },
  ];
  console.log("gst2ATable4ReportsData: ", gst2ATable4ReportsData);
  console.log("gst2ATable3ReportsData: ", gst2ATable3ReportsData);

  return (
    <div>
      {/* GSTR-2A Tables */}
      {/* Table 3 */}
      {gst2ATable3ReportsData?.length > 0 && (
        <>
          <div style={{ width: "100%", margin: "0 auto" }}>
            <h4
              style={{
                padding: "5px",
                borderRadius: 5,
                color: `${themeData?.themeColor}`,
                marginTop: "10px",
                marginBottom: "2px",
                backgroundColor: `${themeData?.themeColor}10`,
              }}
            >
              Table 3: Inward supplies received from a registered person other
              than the supplies attracting reverse charge
            </h4>
            <Table
              bordered
              dataSource={gst2ATable3ReportsData}
              pagination={false}
              size="small"
              style={{ marginBottom: "30px" }}
              columns={table3n4Columns}
              // className="ca-viewmodel-table"
              className={`ca-viewmodel-table Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
              scroll={
                gst2ATable3ReportsData?.length > 15
                  ? { x: 700, y: 620 }
                  : { x: 600 }
              }
            />
          </div>
        </>
      )}

      {/* Table 4 */}
      {gst2ATable4ReportsData?.length > 0 && (
        <>
          <div style={{ width: "100%", margin: "0 auto" }}>
            <h4
              style={{
                padding: "5px",
                borderRadius: 5,
                color: `${themeData?.themeColor}`,
                marginTop: "10px",
                marginBottom: "2px",
                backgroundColor: `${themeData?.themeColor}10`,
              }}
            >
              Table 4: Inward supplies received from a registered person on
              which tax is to be paid on reverse charge
            </h4>
            <Table
              bordered
              dataSource={gst2ATable4ReportsData}
              pagination={false}
              size="small"
              style={{ marginBottom: "30px" }}
              columns={table3n4Columns}
              // className="ca-viewmodel-table"
              className={`ca-viewmodel-table Tabel-style table-${
                themeData?.componentSize ?? "middle"
              }`}
              scroll={
                gst2ATable4ReportsData?.length > 15
                  ? { x: 700, y: 620 }
                  : { x: 600 }
              }
            />
          </div>
        </>
      )}
    </div>
  );
};

export default GSTR2A;
